import * as React from 'react';
import { IconProps } from './type';
import './Icon.scss';
import { getClass } from '../../lib/util';

export * from './type';

export const IconDefaultProps = {
  size: 'md',
};

/**
 *
 * @param param
 */
function Icon({ children, size, title, className }: IconProps): React.ReactElement {
  return (
    <span
      data-testid="elmo-icon"
      title={title}
      className={getClass('elmo-icon', className, { [`size-${size}`]: size })}
    >
      <svg
        focusable="false"
        viewBox="0 0 24 24"
        aria-hidden="true"
        role="presentation"
        className="elmo-icon__svg"
      >
        {children}
      </svg>
    </span>
  );
}

export function withIcon(iconComponent: React.ReactElement) {
  return ({ size, title, className }: IconProps): React.ReactElement => (
    <Icon size={size} title={title} className={className}>
      {React.cloneElement(iconComponent, {})}
    </Icon>
  );
}

Icon.defaultProps = IconDefaultProps;

export default Icon;
